import { useState, useEffect } from 'react';

const RESIZING_TIMEOUT = 200;

interface CurrentWindow {
  width: number;
  height: number;
  resizing: boolean;
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

export const useWindow = (): CurrentWindow => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [resizing, setResizing] = useState<boolean>(false);

  useEffect(() => {
    let resizeTimeout: NodeJS.Timeout;

    function handleResize() {
      const { innerWidth: newWidth } = window;

      if (newWidth !== windowDimensions.width) {
        setWindowDimensions(getWindowDimensions());
        setResizing(true);
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
          setResizing(false);
        }, RESIZING_TIMEOUT);
      }
    }

    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener('resize', handleResize);
    };
  }, [windowDimensions.width]);

  return {
    width: windowDimensions.width,
    height: windowDimensions.height,
    resizing,
  };
};
